import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { sanitizeDate } from '@/utils/dates'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export function useUpdateClientProcuracao() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_client, update }: { id_client: string; update: any }) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        procuracaoHabilitada: update.procuracaoHabilitada || '',
        procuracaoHabilitadaEm: sanitizeDate(update?.procuracaoHabilitadaEm) || '',
        procuracaoValidaAte: sanitizeDate(update.procuracaoValidaAte) || ''
      }

      const response = await api.post(`/clients/update/${id_client}`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar cliente')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] }) // Invalida a lista de clientes para obter os dados atualizados
      queryClient.refetchQueries({ queryKey: ['clients'] }) // Invalida a lista de clientes para obter os dados atualizados
    }
  })
}
